// src/com/tsr/TransPlanTsrViewBulkDetail.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import { AppStyle } from '../../value/AppConst';
import { bulkCompanyProductsListRepo, transPlanTsrItemRepo } from '../../value/AppModel';
import { useReactiveVar } from '@apollo/client';
import {
    mergeBulkCountAndMakeBulkProductsCompanyTree
} from '../bulk_company_products/BulkCompanyProductsGql';

const ProductLabelWidth = 100;
const CompanyLabelWidth = 220;
const QuantityLabelWidth = 120;
const TotalWidth = ProductLabelWidth + CompanyLabelWidth + QuantityLabelWidth;

const TitleHeader = styled(Box)({
    backgroundColor: AppStyle.PrimaryRGB, color: 'white', fontWeight: 'bold',
    display: 'flex', height: 40, // width: TotalWidth,
});

const ColumnBody = styled(Box)({
    flex: 1, overflow: 'auto', borderBottom: AppStyle.BorderCCC, boxSizing: 'border-box',
});

const TitleCell = styled(Box)({
    display: 'flex', justifyContent: 'center', alignItems: 'center',
})
const ProdTreeBox = styled(Box)({
    display: 'flex', borderBottom: AppStyle.BorderCCC, fontSize: '0.8rem', textAlign: 'center'
});
const ProdLabel = styled(Box)({
    backgroundColor: '#eee', width: ProductLabelWidth,
    padding: '10px 0px 10px 0px', // 스크롤하지 않아도 위에 보이도록 ..
    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
});
const ProdTotalQty = styled('div')({color: 'blue', fontSize: '0.7rem',});

const CompanyListBox = styled(Box)({flexGrow: 1});
const CompanyRecord = styled(Box)({
    display: 'flex', borderBottom: AppStyle.BorderCCC,
    // even background color
    '&:nth-of-type(odd)': {backgroundColor: '#f9f9f9'},
    '&:last-of-type': {borderBottom: 'none'},
});
const CompanyLabel = styled(Box)({
    width: CompanyLabelWidth, display: 'flex', alignItems: 'center', justifyContent: 'center',
});
const InputBox = styled(Box)({flexGrow: 1, });

function sumQuantities(tree) {
    let sum = 0;
    tree.forEach(prod => {
        prod.companies.forEach(com => {
            sum += com.quantity;
        });
    });
    return sum;
}
/**
 * 벌크 상차 상세내역
 * @param {*} param0 
 * @returns 
 */
export default function TransPlanTsrViewBulkDetail() {
    const item = useReactiveVar(transPlanTsrItemRepo);
    const bulkCompanyProductsListData = useReactiveVar(bulkCompanyProductsListRepo);
    const [productTree, setProductTree] = useState([]);
    const [sum, setSum] = useState(0);

    useEffect(()=>{
        if(item && bulkCompanyProductsListData.records.length > 0) {
            const newTrees = mergeBulkCountAndMakeBulkProductsCompanyTree(bulkCompanyProductsListData.records, item.bulkItems || []); // 982라 하더라도 bulkItems가 없는 경우 있음.
            setProductTree(newTrees);
            setSum(sumQuantities(newTrees));
        }
    }, [bulkCompanyProductsListData, item]);

    const renderCompany = (company) => {
        return (
            <CompanyRecord key={company.bulkCompanyId}>
                <CompanyLabel
                    style={{
                        color: company.quantity > 0 ? 'blue' : 'inherit'
                    }}
                >{company.comName}</CompanyLabel>
                <InputBox>{company.quantity}</InputBox>
            </CompanyRecord>
        );
    };

    const renderProductTree = (product) => {
        const qtyAll = product.companies.reduce((acc, cur) => acc + cur.quantity, 0);
        return (
            <ProdTreeBox key={product.bulkProductsId}>
                <ProdLabel>
                    {product.prodName}
                    {
                        qtyAll > 0 && product.companies.length > 0 &&
                        <ProdTotalQty>[{qtyAll}]</ProdTotalQty>
                    }
                </ProdLabel>
                <CompanyListBox>
                    {product.companies.map(renderCompany)}
                </CompanyListBox>
            </ProdTreeBox>
        )
    }

    // PC 버전은 2개의 트리로 나누어 2개 칼럼으로 나누었음.
    // 모바일 버전은 1개 트리로 구성. (2개로 나누면 너무 좁아짐)
    // 반드시 테스트해서 확인할 것.
    return (
        <Box
            style={{
                display: 'flex', flexDirection: 'column',
            }}
        >
            <TitleHeader>
                <TitleCell style={{width: ProductLabelWidth}}>구분</TitleCell>
                <TitleCell style={{width: CompanyLabelWidth}}>협력업체명</TitleCell>
                <TitleCell style={{flexGrow:1}}>
                    Pallet
                    {
                        sum > 0 &&
                        <span>[{sum}]</span>
                    }
                </TitleCell>
            </TitleHeader>
            <ColumnBody>
                {productTree.map(renderProductTree)}
            </ColumnBody>
        </Box>
    );
}
